import { c as _c } from "react/compiler-runtime";
import { StoreImageEnum } from '@systemeio/digital-store-shared';
import { FormInput } from '@systemeio/ui';
import StoreFields from 'modules/stores/store/components/contact-fields';
import ItemSteps from 'modules/stores/store/components/item-steps';
import StoreImageSelector from 'modules/stores/store/components/store-image-selector';
import { StoreTextEditor } from 'modules/stores/store/components/store-text-editor';
import { PhysicalProductItemEditType, PhysicalProductItemErrorsType } from 'modules/stores/store/content/product/types/product-interface';
import { Dispatch, SetStateAction } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import PaymentMethodsEditModal from '../../components/payment-methods-edit-modal';
import { twJoin } from 'tailwind-merge';
import { physicalProductInitFields } from '../constants/mandatory-fields';
interface PhysicalCheckoutProps {
  tempState: PhysicalProductItemEditType;
  setTempState: Dispatch<SetStateAction<PhysicalProductItemEditType>>;
  errors: PhysicalProductItemErrorsType;
  imageType: StoreImageEnum;
}
export const PhysicalCheckout = t0 => {
  const $ = _c(78);
  const {
    tempState,
    setTempState,
    errors,
    imageType
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] !== t) {
    t1 = t("dashboard.store.image.select_image");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = tempState.checkoutPage.cover;
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.store.product.checkout_image_label");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== setTempState) {
    t4 = dataFile => setTempState(prev => ({
      ...prev,
      checkoutPage: {
        ...prev.checkoutPage,
        cover: dataFile
      }
    }));
    $[4] = setTempState;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== imageType || $[7] !== t3 || $[8] !== t4 || $[9] !== tempState.checkoutPage.cover) {
    t5 = <StoreImageSelector dataFile={t2} imageType={imageType} label={t3} onChange={t4} />;
    $[6] = imageType;
    $[7] = t3;
    $[8] = t4;
    $[9] = tempState.checkoutPage.cover;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t5) {
    t6 = {
      key: "image",
      title: t1,
      element: t5
    };
    $[11] = t1;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("dashboard.store.item.add_text");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = tempState.checkoutPage.title;
  let t9;
  if ($[16] !== t) {
    t9 = t("dashboard.store.item.title");
    $[16] = t;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== setTempState) {
    t10 = t11 => {
      const {
        target: t12
      } = t11;
      const {
        value
      } = t12;
      return setTempState(prev_0 => ({
        ...prev_0,
        checkoutPage: {
          ...prev_0.checkoutPage,
          title: value
        }
      }));
    };
    $[18] = setTempState;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = errors["checkoutPage.title"];
  let t12;
  if ($[20] !== t10 || $[21] !== t11 || $[22] !== t9 || $[23] !== tempState.checkoutPage.title) {
    t12 = <FormInput required={true} value={t8} label={t9} onChange={t10} error={t11} />;
    $[20] = t10;
    $[21] = t11;
    $[22] = t9;
    $[23] = tempState.checkoutPage.title;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  const t13 = tempState.checkoutPage.buttonTitle;
  let t14;
  if ($[25] !== t) {
    t14 = t("dashboard.store.item.button");
    $[25] = t;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== setTempState) {
    t15 = t16 => {
      const {
        target: t17
      } = t16;
      const {
        value: value_0
      } = t17;
      return setTempState(prev_1 => ({
        ...prev_1,
        checkoutPage: {
          ...prev_1.checkoutPage,
          buttonTitle: value_0
        }
      }));
    };
    $[27] = setTempState;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = errors["checkoutPage.buttonTitle"];
  let t17;
  if ($[29] !== t14 || $[30] !== t15 || $[31] !== t16 || $[32] !== tempState.checkoutPage.buttonTitle) {
    t17 = <FormInput required={true} value={t13} label={t14} onChange={t15} error={t16} />;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
    $[32] = tempState.checkoutPage.buttonTitle;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t12 || $[35] !== t17) {
    t18 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t12}{t17}</div>;
    $[34] = t12;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("dashboard.store.item.description");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  const t20 = tempState.checkoutPage.description;
  let t21;
  if ($[39] !== setTempState) {
    t21 = value_1 => setTempState(prev_2 => ({
      ...prev_2,
      checkoutPage: {
        ...prev_2.checkoutPage,
        description: value_1
      }
    }));
    $[39] = setTempState;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  const t22 = errors["checkoutPage.description"] && "border-danger";
  let t23;
  if ($[41] !== t22) {
    t23 = twJoin(t22);
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  const t24 = errors["checkoutPage.description"];
  let t25;
  if ($[43] !== t19 || $[44] !== t21 || $[45] !== t23 || $[46] !== t24 || $[47] !== tempState.checkoutPage.description) {
    t25 = <StoreTextEditor label={t19} required={true} content={t20} onChange={t21} className={t23} error={t24} />;
    $[43] = t19;
    $[44] = t21;
    $[45] = t23;
    $[46] = t24;
    $[47] = tempState.checkoutPage.description;
    $[48] = t25;
  } else {
    t25 = $[48];
  }
  let t26;
  if ($[49] !== t18 || $[50] !== t25) {
    t26 = <div className="flex flex-col gap-5">{t18}{t25}</div>;
    $[49] = t18;
    $[50] = t25;
    $[51] = t26;
  } else {
    t26 = $[51];
  }
  let t27;
  if ($[52] !== t26 || $[53] !== t7) {
    t27 = {
      key: "text",
      title: t7,
      element: t26
    };
    $[52] = t26;
    $[53] = t7;
    $[54] = t27;
  } else {
    t27 = $[54];
  }
  let t28;
  if ($[55] !== t) {
    t28 = t("dashboard.store.item.collect_info");
    $[55] = t;
    $[56] = t28;
  } else {
    t28 = $[56];
  }
  let t29;
  if ($[57] !== setTempState) {
    t29 = fields => setTempState(prev_3 => ({
      ...prev_3,
      checkoutPage: {
        ...prev_3.checkoutPage,
        fields
      }
    }));
    $[57] = setTempState;
    $[58] = t29;
  } else {
    t29 = $[58];
  }
  const t30 = errors["checkoutPage.fields"];
  let t31;
  if ($[59] !== t29 || $[60] !== t30 || $[61] !== tempState.checkoutPage.fields) {
    t31 = <StoreFields fields={tempState.checkoutPage.fields} onChange={t29} initFields={physicalProductInitFields} error={t30} />;
    $[59] = t29;
    $[60] = t30;
    $[61] = tempState.checkoutPage.fields;
    $[62] = t31;
  } else {
    t31 = $[62];
  }
  let t32;
  if ($[63] !== t28 || $[64] !== t31) {
    t32 = {
      key: "fields",
      title: t28,
      element: t31
    };
    $[63] = t28;
    $[64] = t31;
    $[65] = t32;
  } else {
    t32 = $[65];
  }
  let t33;
  if ($[66] !== t) {
    t33 = t("dashboard.store.product.checkout.payment_methods");
    $[66] = t;
    $[67] = t33;
  } else {
    t33 = $[67];
  }
  const t34 = errors["digitalStore.paymentMethods"];
  let t35;
  if ($[68] !== t34) {
    t35 = <PaymentMethodsEditModal errors={{
      paymentMethods: t34
    }} />;
    $[68] = t34;
    $[69] = t35;
  } else {
    t35 = $[69];
  }
  let t36;
  if ($[70] !== t33 || $[71] !== t35) {
    t36 = {
      key: "payment methods",
      title: t33,
      element: t35
    };
    $[70] = t33;
    $[71] = t35;
    $[72] = t36;
  } else {
    t36 = $[72];
  }
  let t37;
  if ($[73] !== t27 || $[74] !== t32 || $[75] !== t36 || $[76] !== t6) {
    t37 = <ItemSteps steps={[t6, t27, t32, t36]} />;
    $[73] = t27;
    $[74] = t32;
    $[75] = t36;
    $[76] = t6;
    $[77] = t37;
  } else {
    t37 = $[77];
  }
  return t37;
};